import React from 'react';
import './theme.css';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import ContactPage from './ContactPage';
import FAQPage from './FaqPage';
import PrivacyPage from './PrivacyPage';
import ChangelogPage from './ChangelogPage';
import BlogPage from './BlogPage';
import UpdateArticlePage from './UpdateArticlePage';
import SeoContentPage from './SeoContentPage';
import OpenAIKeyGuidePage from './OpenAIKeyGuidePage';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import ScrollManager from './components/ScrollManager';
import WaitlistModal from './components/WaitlistModal';
import AnalyticsRouteTracker from './AnalyticsRouteTracker';
import RouteMetadata from './RouteMetadata';
import { ThemeProvider } from './theme/ThemeProvider';
import { ConsentProvider } from './consent/ConsentContext';

export default function App(){
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ConsentProvider>
          <ScrollManager />
        <AnalyticsRouteTracker />
        <RouteMetadata />
        <NavBar />
        <Routes>
          <Route path="/" element={<LandingPage/>} />
          <Route path="/contact" element={<ContactPage/>} />
          <Route path="/faq" element={<FAQPage/>} />
          <Route path="/privacy" element={<PrivacyPage/>} />
          <Route path="/changelog" element={<ChangelogPage/>} />
          <Route path="/blog" element={<BlogPage/>} />
          <Route path="/blog/guides" element={<BlogPage category="Guide" />} />
          <Route path="/blog/solutions" element={<BlogPage category="Solution" />} />
          <Route path="/blog/guides/prompting-with-purpose" element={<UpdateArticlePage/>} />
          <Route path="/blog/guides/prompt-engineering-basics" element={<SeoContentPage path="/blog/guides/prompt-engineering-basics" />} />
          <Route path="/blog/guides/how-to-write-better-prompts" element={<SeoContentPage path="/blog/guides/how-to-write-better-prompts" />} />
          <Route path="/blog/guides/create-openai-api-key" element={<OpenAIKeyGuidePage />} />
          <Route path="/blog/solutions/prompt-management" element={<SeoContentPage path="/blog/solutions/prompt-management" />} />
          <Route path="/updates" element={<Navigate to="/blog" replace />} />
          <Route path="/updates/prompting-with-purpose" element={<Navigate to="/blog/guides/prompting-with-purpose" replace />} />
          <Route path="/updates/:slug" element={<Navigate to="/blog" replace />} />
          <Route path="/blog/prompting-with-purpose" element={<Navigate to="/blog/guides/prompting-with-purpose" replace />} />
          <Route path="/blog/:slug" element={<Navigate to="/blog" replace />} />
          <Route path="/solutions/prompt-management" element={<Navigate to="/blog/solutions/prompt-management" replace />} />
          <Route path="/guides/prompt-engineering-basics" element={<Navigate to="/blog/guides/prompt-engineering-basics" replace />} />
          <Route path="/guides/how-to-write-better-prompts" element={<Navigate to="/blog/guides/how-to-write-better-prompts" replace />} />
          <Route path="/guides/create-openai-api-key" element={<Navigate to="/blog/guides/create-openai-api-key" replace />} />

        </Routes>
        <Footer />
        <WaitlistModal />
        </ConsentProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
